import React, { forwardRef, HTMLAttributes, ReactNode } from "react";

import classNames from "classnames";

import { useInitScrollRef } from "../../hooks";
import useForkRef from "../../utils/useForkRef";

interface IScrollElement extends HTMLAttributes<HTMLElement> {
  as?: string;
  children?: ReactNode;
  invert?: boolean;
}

export const ScrollElement = forwardRef<HTMLElement, IScrollElement>(
  ({ as = "div", className, invert = false, style, ...rest }, ref) => {
    const internalRef = useInitScrollRef(null, invert);
    const handleRef = useForkRef(internalRef, ref);

    const props = {
      ...rest,
      ref: handleRef,
      className: classNames("c-scroll-element", className),
      style: { overflow: "auto", ...style },
    };

    return React.createElement(as, props);
  }
);

ScrollElement.displayName = "ScrollElement";
